/* unplugin-vue-components disabled */import script from "./SendingExpress.vue?vue&type=script&lang=ts&setup=true"
export * from "./SendingExpress.vue?vue&type=script&lang=ts&setup=true"

import "./SendingExpress.vue?vue&type=style&index=0&id=d0960fe8&lang=less&scoped=true"

import exportComponent from "/data/liulv-h5/quantum-technology/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0960fe8"]])

export default __exports__